/* src/app/hire-talent-insights/hire-talent-insights.component.scss */
.margin-auto {
  margin: auto !important;
}
.wc-my-auto {
  margin-bottom: auto !important;
  margin-top: auto !important;
}
.ml--1 {
  margin-left: -1px;
}
.ml--2 {
  margin-left: -2px;
}
.ml--3 {
  margin-left: -3px;
}
.ml--4 {
  margin-left: -4px;
}
.ml--5 {
  margin-left: -5px;
}
.ml--6 {
  margin-left: -6px;
}
.ml--7 {
  margin-left: -7px;
}
.ml--8 {
  margin-left: -8px;
}
.ml--9 {
  margin-left: -9px;
}
.ml--10 {
  margin-left: -10px;
}
.ml--15 {
  margin-left: -15px;
}
.mr--5 {
  margin-right: -5px;
}
.mr--10 {
  margin-right: -10px;
}
.mr--15 {
  margin-right: -15px;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.ml-0 {
  margin-left: 0 !important;
}
.mr-0 {
  margin-right: 0 !important;
}
.m-1 {
  margin: 5px !important;
}
.my-1 {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.mx-1 {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
.mt-1 {
  margin-top: 5px !important;
}
.mb-1 {
  margin-bottom: 5px !important;
}
.ml-1 {
  margin-left: 5px !important;
}
.mr-1 {
  margin-right: 5px !important;
}
.mb-1-5 {
  margin-bottom: 7.5px !important;
}
.m-2 {
  margin: 10px !important;
}
.my-2 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.mx-2 {
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.mt-2 {
  margin-top: 10px !important;
}
.mb-2 {
  margin-bottom: 10px !important;
}
.ml-2 {
  margin-left: 10px !important;
}
.mr-2 {
  margin-right: 10px !important;
}
.m-3 {
  margin: 15px !important;
}
.my-3 {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}
.mx-3 {
  margin-left: 15px !important;
  margin-right: 15px !important;
}
.mt-3 {
  margin-top: 15px !important;
}
.mb-3 {
  margin-bottom: 15px !important;
}
.ml-3 {
  margin-left: 15px !important;
}
.mr-3 {
  margin-right: 15px !important;
}
.m-4 {
  margin: 20px !important;
}
.my-4 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.mx-4 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}
.mt-4 {
  margin-top: 20px !important;
}
.mb-4 {
  margin-bottom: 20px !important;
}
.ml-4 {
  margin-left: 20px !important;
}
.mr-4 {
  margin-right: 20px !important;
}
.m-5 {
  margin: 25px !important;
}
.my-5 {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
}
.mx-5 {
  margin-left: 25px !important;
  margin-right: 25px !important;
}
.mt-5 {
  margin-top: 25px !important;
}
.mb-5 {
  margin-bottom: 25px !important;
}
.ml-5 {
  margin-left: 25px !important;
}
.mr-5 {
  margin-right: 25px !important;
}
.m-6 {
  margin: 30px !important;
}
.my-6 {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}
.mx-6 {
  margin-left: 30px !important;
  margin-right: 30px !important;
}
.mt-6 {
  margin-top: 30px !important;
}
.mb-6 {
  margin-bottom: 30px !important;
}
.ml-6 {
  margin-left: 30px !important;
}
.mr-6 {
  margin-right: 30px !important;
}
.mb-8 {
  margin-bottom: 40px !important;
}
.p-0 {
  padding: 0 !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.pt-0 {
  padding-top: 0 !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.pr-0 {
  padding-right: 0 !important;
}
.p-1 {
  padding: 5px !important;
}
.py-1 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.px-1 {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.pt-1 {
  padding-top: 5px !important;
}
.pb-1 {
  padding-bottom: 5px !important;
}
.pl-1 {
  padding-left: 5px !important;
}
.pr-1 {
  padding-right: 5px !important;
}
.p-2 {
  padding: 10px !important;
}
.py-2 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.px-2 {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.pt-2 {
  padding-top: 10px !important;
}
.pb-2 {
  padding-bottom: 10px !important;
}
.pl-2 {
  padding-left: 10px !important;
}
.pr-2 {
  padding-right: 10px !important;
}
.p-3 {
  padding: 15px !important;
}
.py-3 {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.px-3 {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.pt-3 {
  padding-top: 15px !important;
}
.pb-3 {
  padding-bottom: 15px !important;
}
.pl-3 {
  padding-left: 15px !important;
}
.pr-3 {
  padding-right: 15px !important;
}
.p-4 {
  padding: 20px !important;
}
.py-4 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.px-4 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.pt-4 {
  padding-top: 20px !important;
}
.pb-4 {
  padding-bottom: 20px !important;
}
.pl-4 {
  padding-left: 20px !important;
}
.pr-4 {
  padding-right: 20px !important;
}
.p-5 {
  padding: 25px !important;
}
.py-5 {
  padding-top: 25px !important;
  padding-bottom: 25px !important;
}
.px-5 {
  padding-left: 25px !important;
  padding-right: 25px !important;
}
.pt-5 {
  padding-top: 25px !important;
}
.pb-5 {
  padding-bottom: 25px !important;
}
.pl-5 {
  padding-left: 25px !important;
}
.pr-5 {
  padding-right: 25px !important;
}
.p-6 {
  padding: 30px !important;
}
.py-6 {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}
.px-6 {
  padding-left: 30px !important;
  padding-right: 30px !important;
}
.pt-6 {
  padding-top: 30px !important;
}
.pb-6 {
  padding-bottom: 30px !important;
}
.pl-6 {
  padding-left: 30px !important;
}
.pr-6 {
  padding-right: 30px !important;
}
.px-7 {
  padding-left: 35px !important;
  padding-right: 35px !important;
}
.py-7 {
  padding-top: 35px !important;
  padding-bottom: 35px !important;
}
.pb-7 {
  padding-bottom: 35px !important;
}
.px-8 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}
.py-8 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}
.pb-8 {
  padding-bottom: 40px !important;
}
.pt-8 {
  padding-top: 40px !important;
}
.text-justify {
  text-align: justify !important;
}
.text-wrap {
  white-space: normal !important;
}
.text-nowrap {
  white-space: nowrap !important;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
.text-lowercase {
  text-transform: lowercase !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.font-weight-light {
  font-weight: 300 !important;
}
.font-weight-lighter {
  font-weight: lighter !important;
}
.font-weight-normal {
  font-weight: 400 !important;
}
.font-weight-500 {
  font-weight: 500 !important;
}
.font-weight-600 {
  font-weight: 600 !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.font-weight-bolder {
  font-weight: bolder !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  display: block;
  color: #000;
}
.text-blue {
  color: #2e93a1 !important;
}
.text-green {
  color: #229300;
}
.text-danger {
  color: #DE0000;
}
.text-defualt {
  color: #484b59;
  font-weight: 100;
}
.gray-text {
  color: #777777;
}
.text-light-grey {
  color: #949494 !important;
}
.text-white {
  color: #fff;
}
.text-black {
  color: #484b59 !important;
}
.text-orange {
  color: #FF9B05 !important;
}
.text-pink {
  color: #e85d75;
}
.text-dis {
  color: #CCCCCC;
}
.text-light-blue {
  color: #8fdde4;
}
.text-light-orange {
  color: #ffcd82;
}
.text-light-purple {
  color: #d6bdff;
}
.text-6767 {
  color: #676767;
}
.text-warning {
  color: #FFC400 !important;
}
a {
  color: #4dc7f4;
  outline: none;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  cursor: pointer;
  color: #4dc7f4;
}
.spacer {
  width: 1px;
  height: 1px;
}
.spacer2 {
  width: 1px;
}
.wc-d-block {
  display: block;
}
.wc-d-inline {
  display: inline;
}
.wc-d-inline-block {
  display: inline-block;
}
.wc-label {
  display: block;
  font-size: 14px;
  color: #000;
  padding-bottom: 5px;
}
.wc-form-control {
  border-radius: 2px;
  border: 2px solid #d6dde6;
  font-size: 14px;
  line-height: 1.2;
  padding: 6px 12px;
  height: 36px;
  width: 100%;
}
.wc-form-control:focus {
  border-color: #2e93a1;
  outline: none;
}
.wc-textarea {
  height: 100%;
}
.hr-color {
  border-bottom: 1px solid #676767;
}
.hr-color .wc-hr {
  display: inline;
}
.w-100 {
  width: 100%;
}
.h-15 {
  height: 18px;
}
.f-8 {
  font-size: 8px;
  line-height: 1.3;
}
.f-10 {
  font-size: 10px;
  line-height: 1.3;
}
.f-11 {
  font-size: 11px;
  line-height: 1.3;
}
.f-12 {
  font-size: 12px;
  line-height: 1.3;
}
.f-16 {
  font-size: 16px;
  line-height: 1.3;
}
.f-14 {
  font-size: 14px;
  line-height: 1.3;
}
.f-18 {
  font-size: 18px;
  line-height: 1.3;
}
.f-20 {
  font-size: 20px;
  line-height: 1.3;
}
.f-22 {
  font-size: 22px;
  line-height: 1.3;
}
.f-24 {
  font-size: 24px;
  line-height: 1.3;
}
.f-26 {
  font-size: 26px;
  line-height: 1.3;
}
.f-28 {
  font-size: 28px;
  line-height: 1.3;
}
.f-30 {
  font-size: 30px;
  line-height: 1.3;
}
.f-32 {
  font-size: 32px;
  line-height: 1.3;
}
.sep-tag {
  color: #676767;
  font-weight: 500;
  padding-bottom: 15px;
  background-color: #fff;
}
.category {
  color: #949494;
  font-weight: 500;
}
.wc-select {
  background-color: #fff;
  color: #676767;
}
.wc-select option {
  color: #484b59;
}
.wc-select option:disabled {
  color: #676767;
}
.wc-float-right {
  float: right;
}
.wc-float-left {
  float: left;
}
.wc-sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 60px;
  z-index: 1020;
  padding-top: 20px;
  padding-bottom: 40px;
  background-color: #fff;
  transition: all 0.3s;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.wc-upload-btn {
  width: 100px;
  height: 100px;
  border: 1px solid #777777;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  background-color: white;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.wc-upload-btn i {
  font-size: 16px;
  color: #2e93a1;
  position: relative;
  top: 45px;
  color: #2e93a1;
}
.wc-upload-btn .upload-sign {
  position: relative;
  top: 48px;
}
.wc-upload-btn input {
  position: absolute;
  cursor: pointer;
  font-size: 50px;
  opacity: 0;
  right: 0;
  top: 0;
}
.b {
  border: none;
}
.bl,
.bx {
  border-left: none;
}
.br,
.bx {
  border-right: none;
}
.bt,
.by {
  border-top: none;
}
.bb,
.by {
  border-bottom: none;
}
.wc-border {
  border: 1px solid #d1d1d1;
}
.wc-gray-border {
  border: 1px solid #484b59;
}
.br-0 {
  border-radius: inherit !important;
}
.brr-0 {
  border-top-right-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.brl-0 {
  border-top-left-radius: inherit !important;
  border-bottom-left-radius: inherit !important;
}
.brt-0 {
  border-top-left-radius: inherit !important;
  border-top-right-radius: inherit !important;
}
.brb-0 {
  border-bottom-left-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 16px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  background-color: white;
  border: 2px solid #777777;
  box-sizing: border-box;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: -1px;
  bottom: 0px;
  background-color: #777777;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: white;
  border-color: #80d7f8;
}
input:focus + .slider {
  box-shadow: 0 0 1px #80d7f8;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  left: -10px;
  margin-right: -4px;
  background-color: #80d7f8;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.forms-top-header {
  width: calc(100% - 145px);
  position: fixed;
  top: 60px;
  margin: 0;
  padding: 20px 0 20px 0;
  background-color: #fff;
  z-index: 2;
}
.main-form {
  position: relative;
  top: 100px;
}
.wc-btn:hover {
  color: #ffffff;
  background-color: #206C79;
}
.wc-btn:focus {
  outline: none;
}
.wc-btn {
  padding: 7px 21px;
  color: #ffffff;
  font-weight: 100;
  border-radius: 2px;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-xs {
  padding: 3px 20px;
  border-radius: 16px;
  color: #ffffff;
  font-weight: 600;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-validate {
  background-color: #4a90e2;
}
.wc-btn-registered {
  background-color: #ffcd82;
}
.wc-primary {
  background-color: #2e93a1;
}
.wc-gray-btn {
  background-color: #999999;
}
.wc-white-btn {
  background-color: #fff;
  color: #484b59;
  border: 2px solid #d6dde6 !important;
}
.wc-primary {
  background-color: #2e93a1;
}
.line-height-1 {
  line-height: 1.6;
}
.line-height {
  line-height: 0px;
}
.hc {
  color: #484b59;
}
.bg-blue {
  background-color: #2E93A1;
}
.bg-blue-light {
  background-color: #b3e7fa;
}
.bg-blue-dark {
  background-color: #4a90e2;
}
.bg-blue-2 {
  background-color: #8fdde4;
}
.bg-orange {
  background-color: #FF9B05;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-gray {
  background-color: #fafafc !important;
}
.bg-gray-dark-2 {
  background-color: #d6dde6;
}
.bg-gray-dark {
  background-color: #d1d1d1;
}
.bg-gray-light {
  background-color: #fafafc;
}
.bg-red-light {
  background-color: #ead1d2;
}
.bg-red {
  background-color: #DE0000;
}
.bg-white {
  background-color: #ffffff;
}
.bg-green {
  background-color: #229300;
}
.bg-brawn {
  background-color: #cbaea5;
}
.bg-black {
  background-color: #484b59;
}
.nobg {
  background-color: transparent;
}
.btn-bg-black {
  background-color: #334059;
}
.btn-interview {
  padding: 8px 15px;
  letter-spacing: 4;
  color: #586e9a;
  border-radius: 2px;
  border: solid 1px #586e9a;
  transition: all 0.5s;
  background-color: #ffffff;
}
.btn-interview:hover,
.btn-interview:active,
.btn-interview:focus {
  color: #ffffff;
  border: solid 1px #586e9a;
  background-color: #586e9a;
}
.red-border {
  border: 1px solid #DE0000;
}
.blue-border {
  border: 1px solid #2e93a1;
}
.black-border {
  border: solid 1px #2C2C2C;
}
.border-stepper {
  border: solid 1px #334059;
}
.step-gray-border {
  border: solid 1px #d1d1d1;
}
.gt {
  color: #999999;
}
.text-blue-gray {
  color: #8094B1;
}
.light-blue-text {
  color: #012964;
}
.black-text {
  color: #000;
}
.green-text {
  color: #4ac98d;
}
.wccard {
  border-radius: 2px;
  background-color: #fff;
}
.wc-border {
  border: 2px solid #ECF0F4;
}
.wc-bl {
  border-left: 2px solid #ECF0F4;
}
.wc-br {
  border-right: 2px solid #ECF0F4;
}
.wc-bt {
  border-top: 2px solid #ECF0F4;
}
.wc-bb {
  border-bottom: 2px solid #ECF0F4;
}
.bg-warning {
  background-color: #FFC400;
}
.bg-light-green {
  background-color: #d3e9cc;
}
.bg-light-red {
  background-color: rgba(222, 0, 0, 0.2);
}
.paused-color {
  background-color: #FFF3CC;
}
.bg-img {
  background-color: #f5f6f9;
}
.hrcolor {
  border-top: 1px solid #ECF0F4;
}
.z-1 {
  z-index: -1;
}
.z0 {
  z-index: 0;
}
.z1 {
  z-index: 1;
}
.z2 {
  z-index: 2;
}
.z3 {
  z-index: 3;
}
.z4 {
  z-index: 4;
}
.z5 {
  z-index: 5;
}
.wc-box-shadow {
  box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
}
.pointer {
  cursor: pointer;
}
.c-logo {
  width: 50px;
  height: 50px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-mini {
  width: 30px;
  height: 30px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo-mini img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md {
  width: 80px;
  height: 80px;
  background-color: rgba(48, 5, 127, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 24px;
}
.c-logo-md img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md i {
  font-size: 40px;
}
.showpassword {
  position: absolute;
  top: 10px;
  right: 4%;
}
.listStyleBullet > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.listStyleBullet > ul li {
  padding: 2px 0;
}
.listStyleBullet div > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.strikethrough {
  text-decoration: line-through;
  color: #999999;
}
.anchor-text {
  color: #4dc7f4 !important;
}
.tl0 {
  top: 0;
  left: 0;
}
.tr0 {
  top: 0;
  right: 0;
}
.ats-cta-btn:hover i {
  color: #206C79;
}
.ats-cta-btn {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-color: #D5E9EC;
  padding: 5px 8px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.ats-cta-btn i {
  color: #2E93A1;
  font-size: 14px;
  font-weight: 600;
}
.wc-progress-profile {
  background-color: rgba(103, 198, 187, 0.2);
  border-radius: 1rem;
}
.wc-progress-profile .wc-progress-bar {
  background-color: rgb(103, 198, 187);
}
.mt-3px {
  margin-top: 3px;
}
.mb-3px {
  margin-bottom: 1px;
}
label {
  font-size: 12px;
}
.no-outline {
  outline: none;
}
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  display: none;
}
.text-484b59 {
  color: #484b59;
}
.yrofexp {
  width: 160px;
  float: left;
}
.yrofexp input[type=number] {
  width: 60px;
  float: left;
  z-index: 2;
  position: relative;
  font-size: 14px;
}
.yrofexp input[type=text] {
  width: 90px;
  float: left;
  z-index: 2;
  margin-left: -2px;
  text-align: center;
}
.yrofexp input[type=text]:focus {
  border: 2px solid #d6dde6;
}
.yrofexp label {
  width: 100px;
  float: left;
  padding: 7.5px 12px;
  border: 2px solid #d6dde6;
  margin-left: -2px;
  border-radius: 0 2px 2px 0;
  color: #000;
  text-align: center;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
.form-control-sm::-webkit-inner-spin-button,
.form-control-sm::-webkit-outer-spin-button {
  -webkit-appearance: auto !important;
  appearance: auto !important;
  margin: 0;
}
.upload-container {
  width: 100%;
  float: left;
  height: 80px;
  color: #2e93a1;
  border: 2px solid #fafafc;
  cursor: pointer;
  position: relative;
  transition: 0.4s;
  border-radius: 2px;
}
.upload-container .upload--btn {
  width: 76px;
  height: 100%;
  padding: 22px 30px;
  background-color: #fafafc;
  font-size: 24px;
  position: absolute;
  transition: 0.4s;
  z-index: 2;
}
.upload-container .upload--section {
  width: 100%;
  text-align: left;
  position: absolute;
  left: 0;
  line-height: 76px;
  padding-left: 100px;
  transition: 0.4s;
  z-index: 0;
}
.upload-container input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.upload-container:hover {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
.upload-container:hover .upload--btn {
  background-color: #2e93a1;
  color: #fff;
  transition: 0.4s;
  z-index: 2;
}
.upload-container:hover .upload--section {
  background-color: #fafafc;
  color: #2e93a1;
  transition: 0.4s;
  z-index: 0;
}
.upload-container:focus {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
#b2bfd0 ::placeholder {
  color: red !important;
}
:-ms-input-placeholder {
  color: red !important;
}
::-ms-input-placeholder {
  color: red !important;
}
.genderBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.genderBtn .genderRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.genderBtn .genderText {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.genderBtn > input[type=radio]:checked + .genderText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  z-index: 2;
}
.wc-checkbox {
  width: 20px !important;
  height: 20px !important;
  position: relative;
  left: 0;
  top: 0;
  cursor: pointer;
}
.wc-checkbox input[type=checkbox] {
  left: 0;
  right: 0;
  width: 20px;
  height: 20px;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
}
.wc-radioBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.wc-radioBtn .teamRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.wc-radioBtn .teamText {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.wc-radioBtn > input[type=radio]:checked + .teamText,
.wc-radioBtn > input[type=checkbox]:checked + .teamText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  cursor: pointer;
}
.wc-ghostBtn {
  padding: 7px 21px;
  border: 1px solid #969696;
  background-color: #fff;
  color: #484b59;
  transition: 0.5s;
  outline: none;
  border-radius: 3px;
}
.wc-ghostBtn:hover {
}
.wc-ghostBtn:focus {
  color: #2e93a1;
  background-color: #fff;
}
.wc-ghostdisabled {
  color: #999999;
  border: 2px solid #999999;
  background-color: #fff;
  outline: none;
}
.wc-ghostBtnRed {
  border: 2px solid #DE0000;
  background-color: #fff;
  color: #DE0000;
  transition: 0.5s;
  outline: none;
}
.wc-ghostBtnRed:hover {
  color: #fff;
  background-color: #DE0000;
}
.wc-ghostBtnRed:focus {
  color: #fff;
  background-color: #DE0000;
}
@media only screen and (max-width: 1440px) {
  .wc-checkbox {
    width: 25px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1368px) {
  .wc-checkbox {
    width: 30px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1170px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media (max-width: 768px) {
  .modal-dialog {
    max-width: 700px;
    margin: 1.75rem auto;
  }
}
@media (max-width: 576px) {
  .modal-dialog {
    max-width: 95%;
    margin: 1.75rem auto;
  }
}
@media only screen and (max-width: 768px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 576px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
.ats-upload-btn {
  width: 100%;
  border: dashed 0.5px #b0bed2;
  color: #484b59;
  display: flex;
  box-sizing: border-box;
  position: relative;
}
.ats-upload-btn span {
  color: #d1d1d1;
  font-size: 34px;
  line-height: 1;
  z-index: 0;
}
.ats-upload-btn .ats--upload-cv,
.ats-upload-btn .ats--upload-linkedin {
  width: 50%;
  float: left;
  padding: 20px;
  border-right: 1px dashed #b0bed2;
  box-sizing: border-box;
  z-index: 0;
}
.ats-upload-btn .ats--upload-linkedin {
  border-right: none;
}
.ats-upload-btn input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.social-check {
  position: relative;
  cursor: pointer;
  margin-right: 10px;
}
.social-check input[type=checkbox] {
  width: 15px;
  height: 15px;
  opacity: 0;
}
.social-check i {
  font-size: 14px;
  position: absolute;
  left: 0;
  top: 0;
  color: #b2bfd0;
  cursor: pointer;
  transition: 0.5s;
}
.social-check input[type=checkbox]:checked + i {
  transition: 0.5s;
  color: #2e93a1;
}
input[type=month]::-webkit-inner-spin-button {
  display: none;
}
input[type=month]::-webkit-calendar-picker-indicator {
  opacity: 0;
  z-index: 2;
}
div.uploadFile {
  position: relative;
}
div.uploadFile input[type=file] {
  width: 100%;
  padding: 6px 12px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: 2;
}
div.uploadFile span {
  position: absolute;
  left: 12px;
  top: 7px;
  z-index: 0;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 93%;
  white-space: nowrap;
}
div.uploadFile span i {
  color: #b2bfd0;
  cursor: pointer;
}
.custom-control-label::before {
  background-color: #fff;
  border: #2e93a1 solid 1px;
}
.custom-control-label::after {
  background-color: #2e93a1;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2e93a1;
  background-color: #2e93a1;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  -webkit-transform: translateX(0.75rem);
  transform: translateX(0.75rem);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #2e93a1;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(48, 5, 127, 0.4);
}
.wc-can-cta .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}
@media (max-width: 576px) {
  .ats-upload-btn {
    width: 100%;
    height: 100%;
    border: dashed 0.5px #b0bed2;
    color: #484b59;
    display: block;
    box-sizing: border-box;
    position: relative;
  }
  .ats-upload-btn span {
    color: #d1d1d1;
    font-size: 50px;
    line-height: 1;
    z-index: 0;
  }
  .ats-upload-btn .ats--upload-cv,
  .ats-upload-btn .ats--upload-linkedin {
    width: 100%;
    float: left;
    padding: 40px;
    border-right: 1px dashed #b0bed2;
    box-sizing: border-box;
    z-index: 0;
    display: block;
    border-bottom: 1px dashed #b0bed2;
  }
  .ats-upload-btn .ats--upload-linkedin {
    border-right: none;
    border-bottom: none;
  }
  .ats-upload-btn input {
    position: absolute;
    height: 100%;
    width: 100%;
    outline: none;
    cursor: pointer;
    opacity: 0;
    display: block;
  }
}
.bg-banner {
  background: url("./media/bg-image-ZQ6KMGTV.png");
  background-position: left top;
  background-size: cover;
  height: 100%;
}
.bg-banner .blueOverlay {
  position: absolute;
  opacity: 0.9;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 333;
  height: 100%;
}
.py-40 {
  padding-top: 45px;
}
.centeredForm {
  margin-top: 80px;
}
.logowidth {
  width: 45px;
  height: auto;
}
.wc-logotext {
  font-size: 30px;
  color: #fff;
}
.text-fafafa {
  color: #fafafa;
}
.iconDiv {
  width: 45px;
  float: left;
}
.textDiv {
  width: calc(100% - 45px);
  float: left;
}
.overlay {
  width: 100%;
  height: 80%;
  background-image:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgb(34, 53, 78));
  position: absolute;
  bottom: 0%;
}
.h100vh {
  height: 100vh;
}
#loginContainer {
  position: fixed;
  top: 0;
  left: 0;
}
@media only screen and (max-width: 600px) {
  .h100vh {
    height: 135vh;
  }
}
.logowidth {
  width: 35px;
  height: auto;
}
.wc-logotext {
  font-size: 22px;
  color: #FF9B05;
  vertical-align: -webkit-baseline-middle;
  line-height: 1;
  font-weight: 600;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: #F5F6F9;
}
.nav-link {
  display: block;
  padding: 0.5rem 2.5rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  font-weight: bold;
  background-color: #2e93a1;
}
.test {
  position: relative;
}
.test input[type=text] {
  background-color: transparent;
  z-index: 1;
}
.test .droparrow-down,
.test .droparrow-up {
  position: absolute;
  top: 9px;
  right: 15px;
  color: #d6dde6;
}
.test .fa-chevron-up {
  display: none;
}
input[type=text]:focus + .droparrow-down .fa-chevron-down {
  display: none;
  color: #2e93a1;
}
input[type=text]:focus + .droparrow-down .fa-chevron-up {
  display: block;
  color: #2e93a1;
}
.progress-c {
  width: 100px;
  height: 100px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
  border: 5px solid #fff;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2e93a1;
  font-weight: bold;
}
.wc-linked-btn-1,
.wc-uplaodrsume-btn-1 {
  width: 45%;
  float: left;
  color: #008bc2;
  border: 2px solid #008bc2;
  border-radius: 2px;
  margin-left: 15px;
  cursor: pointer;
}
.wc-linked-btn-1 .wc-linked-btn-i,
.wc-linked-btn-1 .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1 .wc-linked-btn-i,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  padding: 8px 9px;
  display: inline-flex;
  border-right: 2px solid #008bc2;
  justify-content: center;
}
.wc-linked-btn-1 .wc-linked-btn-t,
.wc-linked-btn-1 .wc-uplaodrsume-btn-t,
.wc-uplaodrsume-btn-1 .wc-linked-btn-t,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-t {
  padding: 3px 10px;
  display: inline-flex;
  justify-content: center;
  width: calc(100% - 36px);
}
.wc-linked-btn-1:hover,
.wc-uplaodrsume-btn-1:hover {
  color: #ffffff;
  background: #008bc2;
  border: 2px solid transparent;
  transition: 0.5s;
}
.wc-linked-btn-1:hover .wc-linked-btn-i,
.wc-linked-btn-1:hover .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-linked-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-uplaodrsume-btn-i {
  border-right: 2px solid #fff;
  padding: 8px 9px;
}
.wc-uplaodrsume-btn-1 {
  position: relative;
  color: #84DA28;
  border: 2px solid #84DA28;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  border-right: 2px solid #84DA28;
}
.wc-uplaodrsume-btn-1 .resumeuplad {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .resumeuplad input[type=file] {
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1:hover {
  background: #84DA28;
}
button.close {
  outline: none;
}
input.wc-form-control:focus {
  z-index: 2;
}
.test input[type=text]:focus {
  z-index: 2;
}
.nl-searh-container {
  position: relative;
  width: 100%;
  height: auto;
}
.nl-searh-container .nl-search-banner {
  height: 250px;
  margin-left: -16px;
  margin-right: -15px;
  margin-top: -15px;
  padding: 16px;
  background-color: #dbf1f0;
  background-image: url("./media/talent-insights-bg-ZLRRJFJS.svg");
  background-size: cover;
  background-position: left top 85%;
  background-repeat: no-repeat;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: column;
}
.nl-searh-container .nl-search-banner h1 {
  font-size: 24px;
  font-weight: 600;
  color: #484b59;
  margin-bottom: 12px;
  text-align: center;
}
.nl-searh-container .nl-search-banner p {
  font-size: 24px;
  font-weight: 400;
  color: #484b59;
  margin-bottom: 0;
  text-align: center;
}
.nl-searh-container .nl-search-box {
  position: relative;
  width: 70%;
  margin-bottom: 40px;
  margin: 0 auto;
  top: -65px;
}
.nl-searh-container .nl-search-box .nl-search-card-top {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2509803922);
  border-radius: 16px;
  padding: 16px;
}
.nl-searh-container .nl-search-box .nl-search-card-top .btn-search-label {
  background: #F4F4F4;
  border: 1px solid #F4F4F4;
  border-radius: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.0588235294);
  padding: 7px 10px;
  color: #484b59;
  margin-left: 10px;
  font-size: 12px;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease-in;
}
.nl-searh-container .nl-search-box .nl-search-card-top .btn-search-label i {
  margin-right: 8px;
}
.nl-searh-container .nl-search-box .nl-search-card-top .btn-search-label:hover {
  background-color: #E6E6E6;
  border-color: #E6E6E6;
}
.nl-searh-container .nl-search-box .nl-search-card-top .nl-input {
  background: #FBFBFB;
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  padding: 15px;
  padding-right: 70px;
  width: 100%;
  font-size: 12px;
  min-height: 68px;
}
.nl-searh-container .nl-search-box .nl-search-card-top .nl-input:focus {
  border: 2px solid #2E93A1;
  outline: none;
}
.nl-searh-container .nl-search-box .nl-search-card-top .nl-input:active {
  border: 2px solid #2E93A1;
}
.nl-searh-container .nl-search-box .nl-search-card-top .nl-input:focus-within {
  border: 2px solid #2E93A1;
}
.nl-searh-container .nl-search-box .nl-search-card-top .nl-input:focus-visible {
  border: 2px solid #2E93A1 !important;
}
.nl-searh-container .nl-search-box .nl-search-card-top .btn-search-input {
  padding: 10px 10px;
  border-radius: 4px;
  background: #E4F1F3;
  box-shadow: 0px 2px 4px -2px rgba(0, 0, 0, 0.1019607843);
  box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1019607843);
  font-size: 12px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  width: 42px;
  position: absolute;
  right: 15px;
  bottom: 36px;
  border-radius: 6px;
}
.nl-searh-container .nl-search-box .nl-chip-container {
  position: relative;
  width: 100%;
  margin-top: 15px;
}
.nl-searh-container .nl-search-box .nl-chip-container .nl-chip {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #ffffff;
  box-shadow: 0 0 8px 0 #EFF1F3;
  border-radius: 20px;
  padding: 6px 12px;
  width: fit-content;
  margin-bottom: 10px;
  gap: 8px;
}
.nl-searh-container .nl-search-box .nl-chip-container .nl-chip span i {
  background-image:
    linear-gradient(
      251deg,
      #c845ab 85%,
      #e24e7f 48%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-right: 10px;
  display: inline-block;
}
.nl-searh-container .nl-search-box .nl-chip-container .nl-chip span {
  font-size: 12px;
  color: #484b59;
}
.nl-searh-container .nl-search-box .nl-chip-container .btn-refresh {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: #E4F1F3;
  color: #2E93A1;
  margin-left: 12px;
  box-shadow: 0px 2px 4px -2px rgba(0, 0, 0, 0.1019607843);
  box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1019607843);
}
.nl-searh-container .empty-card {
  background-color: #fff;
  border: 1px solid #D9D9D9;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: -webkit-fill-available;
  border-radius: 6px;
  overflow: hidden;
}
.nl-searh-container .empty-card p {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 500;
}
.nl-searh-container .empty-card img {
  width: 65px;
  height: 80px;
}
.nl-searh-container .data-card {
  background: #FFFFFF;
  border-top: 1px solid #D9D9D9;
  box-shadow: 0px 0px 2px -1px rgba(0, 0, 0, 0.0901960784);
  padding: 16px 0;
  border-radius: 6px;
}
.nl-searh-container .bbgray {
  border-bottom: 1px solid #D5DEE6;
}
.search-wrapper {
  position: relative;
  width: 300px;
}
.searchlist {
  position: absolute;
  width: 100%;
  background: #fff;
  overflow-y: auto;
  z-index: 2;
  border-radius: 16px;
  border: 1px solid rgba(46, 147, 161, 0.3019607843);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2509803922);
  margin-top: 5px;
}
.option {
  padding: 8px;
  cursor: pointer;
}
.option:hover {
  background-color: #f1f1f1;
}
.search-placeholder {
  color: #969696;
  padding: 15px;
  font-size: 12px;
}
.search-option div {
  padding: 12px;
  color: #484b59;
  font-size: 12px;
}
.search-option div span i {
  color: #2E93A1;
  margin-right: 12px;
}
.search-option div:hover {
  background-color: #EAF4F6;
}
.aistar {
  background-image:
    linear-gradient(
      251deg,
      #c845ab 85%,
      #e24e7f 48%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-right: 10px;
  display: inline-block;
}
.char-count {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}
.ai-search-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.disabled-input {
  pointer-events: none;
  background: #cccccc !important;
}
.highlightelement {
  background-color: #EAF4F6;
}
.profile-matches__list {
  display: flex;
  flex-direction: column;
  padding: 5px 10px;
  overflow: hidden;
}
.profile-match-item {
  padding: 4px 12px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  border-left: 3px solid transparent;
  margin-bottom: 8px;
}
.profile-match-item--active,
.profile-match-item:hover {
  background: #EAF4F6;
  border-left-color: #2E93A1;
}
.profile-match-item__name {
  margin: 0 0 2px;
  font-size: 12px;
  font-weight: 600;
  color: #484b59;
}
.profile-match-item__role {
  margin: 0;
  font-size: 12px;
  color: #969696;
}
::ng-deep .button-place .modal-content {
  position: relative;
}
::ng-deep .button-place .btn-trms-medium {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translateY(50px);
}
::ng-deep .button-place .modal-dialog,
::ng-deep .button-place .modal-content {
  overflow: visible;
}
a.text-webbtree-green:hover {
  text-decoration: underline;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip {
  max-width: 500px !important;
  width: fit-content !important;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip .mat-mdc-tooltip-surface {
  box-shadow: 0 0 4px 0 #e2e0e0;
  font-family: "Poppins", sans-serif !important;
  font-size: 12px !important;
  font-weight: 400;
  font-family: "Poppins", sans-serif !important;
  max-width: 100% !important;
}
::ng-deep ngb-modal-window.new-exp-modal .modal-dialog {
  width: 1126px;
  max-width: 1126px;
}
.mb-120 {
  margin-bottom: 100px;
}
.hire-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  gap: 10px;
  margin-bottom: 12px;
}
.wc-checkbox {
  width: 16px !important;
  height: 16px !important;
}
.wc-checkbox input[type=checkbox] {
  width: 16px !important;
  height: 16px !important;
}
.bb-1 {
  border-bottom: 1px solid #F2F2F2;
}
.common-chip {
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
  color: #68AA86;
  display: flex;
  background:
    linear-gradient(
      0deg,
      rgba(104, 170, 134, 0.1) 0%,
      rgba(104, 170, 134, 0.1) 100%),
    #FFF;
}
.warning {
  border-radius: 6px;
  color: #FBA744;
  background:
    linear-gradient(
      0deg,
      rgba(251, 167, 68, 0.1) 0%,
      rgba(251, 167, 68, 0.1) 100%),
    #FFF;
}
.errror {
  border-radius: 6px;
  color: #E57777;
  background:
    linear-gradient(
      0deg,
      rgba(229, 119, 119, 0.1) 0%,
      rgba(229, 119, 119, 0.1) 100%),
    #FFF;
}
.badge {
  border-radius: 0 8px 8px 0;
  font-size: 12px;
  font-weight: 500;
  padding: 8px 16px 8px 30px;
  position: relative;
}
.badge::before {
  position: absolute;
  display: block;
  content: "";
  left: 0;
  top: 0;
  width: 0px;
  height: 0px;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 18px solid #ffffff;
}
.not-fit {
  background: #FCF1F1;
  color: #E57777;
}
.excellent-fit {
  background: #F0F7F3;
  color: #68AA86;
}
.potential-fit {
  background: #FFF6EC;
  color: #FFA133;
}
.hire-search-card {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.hire-search-card input.wc-form-control {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
}
.filter-criteria-cta {
  padding: 8px 8px;
  border-radius: 4px;
  background: #EAF4F6;
  display: flex;
  align-items: center;
  justify-content: start;
  outline: none;
  border: 0px;
  font-size: 12px;
  height: 36px;
  color: #484b59;
}
.fl-count {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 12px;
  background-color: #2E93A1;
}
.toggle-container {
  background-color: #f7f7f7;
  border-radius: 4px;
  display: flex;
  padding: 2px;
  font-size: 12px;
  font-weight: 500;
  position: relative;
}
.toggle-container .activebtn,
.toggle-container .activeClass {
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
  cursor: pointer;
}
.toggle-container .activeClass {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  height: 100%;
  transition: left 0.3s ease-in-out;
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
}
.toggle-container .insight-btn.activeClass {
  left: 50%;
}
.toggle-container .insight-btn,
.toggle-container .profile-btn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 500;
  border: 1px solid transparent;
  height: auto;
  position: relative;
  cursor: pointer;
}
.toggle-container .insight-btn:hover,
.toggle-container .profile-btn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.toggle-container .activeClass {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  height: 100%;
  transition: left 0.3s ease-in-out;
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
}
.toggle-container .insight-btn.activeClass {
  left: 50%;
}
.toggle-container .profile-btn.activeClass {
  left: -50%;
}
.toggle-container .inactivebtn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 500;
  border: 1px solid transparent;
  height: auto;
  cursor: pointer;
}
.toggle-container .inactivebtn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn button.dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .dropdown-menu.show {
  left: -125px !important;
  transform: translate3d(-33px, 17px, 0px) !important;
  padding: 0;
  overflow: hidden;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  padding: 0.75rem 0.75rem;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #E4F1F3;
}
.sm-reg-btn {
  width: auto;
  min-width: auto;
}
.talenpool-sticky-header {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 3px 5px;
}
.hover-btn {
  transition: all 0.4s ease-in-out;
}
.hover-btn:hover {
  background-color: rgba(46, 147, 161, 0.1019607843);
}
.add-to button.btn-trms-light {
  background-color: #F4F4F4;
  color: #484b59;
}
.add-to .dropdown-menu.show {
  top: 40px;
  left: -55px;
  width: 220px;
  height: 160px;
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid #F5F5F5;
  background: #FFF;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  font-size: 12px;
}
.add-to .dropdown-menu.show .dropdown-item {
  padding: 8px 10px;
}
.add-to .dropdown-menu.show .dropdown-item:hover {
  background-color: #F4F9FA;
  color: #2E93A1 !important;
}
.add-to .dropdown-menu.show .optionheader {
  padding: 10px;
  position: relative;
  color: #969696;
}
.add-to .dropdown-menu.show .optionheader::after {
  position: absolute;
  display: block;
  content: "";
  width: 25%;
  height: 2px;
  background-color: #F2F2F2;
  right: 10px;
  top: 16px;
}
.add-to .dropdown-menu.show::-webkit-scrollbar {
  width: 3px !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-track {
  background: #F2F2F2 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb {
  background: #D9D9D9 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
.add-to.show .dropdown-toggle::after {
  transform: rotate(-180deg);
  transition: transform 0.2s ease-in;
}
.create-project-btn-dropdown {
  border: 0;
  outline: none;
  background-color: #fff;
  color: #484b59;
  padding: 6px 10px;
}
.back-link-btn {
  background-color: transparent;
  color: #484b59;
}
input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
.files-card {
  display: flex;
  padding: 7px 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  background: #FCFCFC;
  flex-direction: column;
  margin-bottom: 10px;
}
.btn-svg {
  border: none;
  outline: none;
  background-color: transparent;
  padding: 5px;
}
::ng-deep .progress {
  background-color: #F4F4F4 !important;
  border-radius: 10px !important;
}
::ng-deep .progress-bar {
  border-radius: 10px !important;
}
::ng-deep .progress-bar.text-bg-success {
  background-color: #2E93A1 !important;
}
textarea.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  min-height: 100px;
}
input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
select.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 34px;
}
.label-style {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 6px;
}
.contact-cta {
  display: flex;
  width: 16px;
  height: 16px;
  padding: 3.326px 3px 2.674px 3px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  border-radius: 100px;
  background: #E6F2F4;
}
.helpfull-label {
  display: flex;
  height: 18px;
  padding: 0 8px;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  border: 1px solid #F2F2F2;
  background: #FAFAFA;
}
.table-view,
.table-view-3-column {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  overflow: hidden;
}
.table-view .table-header-row,
.table-view .table-body-row,
.table-view-3-column .table-header-row,
.table-view-3-column .table-body-row {
  display: flex;
  align-items: stretch;
  gap: 0;
  background-color: #FAFBFC;
  border-bottom: 1px solid #F2F2F2;
}
.table-view .table-header-row .table-header-col,
.table-view .table-header-row .table-body-col,
.table-view .table-body-row .table-header-col,
.table-view .table-body-row .table-body-col,
.table-view-3-column .table-header-row .table-header-col,
.table-view-3-column .table-header-row .table-body-col,
.table-view-3-column .table-body-row .table-header-col,
.table-view-3-column .table-body-row .table-body-col {
  width: 30%;
  padding: 6.68px 16px;
  color: #5E5E5E;
  font-size: 12px;
  font-weight: 500;
  align-content: start;
  border-right: 1px solid #F2F2F2;
}
.table-view .table-header-row .table-header-col:last-child,
.table-view .table-header-row .table-body-col:last-child,
.table-view .table-body-row .table-header-col:last-child,
.table-view .table-body-row .table-body-col:last-child,
.table-view-3-column .table-header-row .table-header-col:last-child,
.table-view-3-column .table-header-row .table-body-col:last-child,
.table-view-3-column .table-body-row .table-header-col:last-child,
.table-view-3-column .table-body-row .table-body-col:last-child {
  border-right: none;
  width: 70%;
}
.table-view .table-header-row .table-header-col:first-child,
.table-view .table-header-row .table-body-col:first-child,
.table-view .table-body-row .table-header-col:first-child,
.table-view .table-body-row .table-body-col:first-child,
.table-view-3-column .table-header-row .table-header-col:first-child,
.table-view-3-column .table-header-row .table-body-col:first-child,
.table-view-3-column .table-body-row .table-header-col:first-child,
.table-view-3-column .table-body-row .table-body-col:first-child {
  width: 30%;
}
.table-view .table-body-row,
.table-view-3-column .table-body-row {
  background-color: #ffffff;
}
.table-view .table-body-row:last-child,
.table-view-3-column .table-body-row:last-child {
  border-bottom: none;
}
.table-view .table-body-row .table-body-col,
.table-view-3-column .table-body-row .table-body-col {
  color: #5E5E5E;
  font-weight: 400;
}
.table-view-3-column .table-header-row .table-header-col,
.table-view-3-column .table-header-row .table-body-col,
.table-view-3-column .table-body-row .table-header-col,
.table-view-3-column .table-body-row .table-body-col {
  padding: 6.68px 16px;
  color: #5E5E5E;
  font-size: 12px;
  font-weight: 500;
  border-right: 1px solid #F2F2F2;
  width: 40%;
  align-content: start;
  gap: 0;
}
.table-view-3-column .table-header-row .table-header-col:last-child,
.table-view-3-column .table-header-row .table-body-col:last-child,
.table-view-3-column .table-body-row .table-header-col:last-child,
.table-view-3-column .table-body-row .table-body-col:last-child {
  border-right: none;
  width: 40%;
}
.table-view-3-column .table-header-row .table-header-col:first-child,
.table-view-3-column .table-header-row .table-body-col:first-child,
.table-view-3-column .table-body-row .table-header-col:first-child,
.table-view-3-column .table-body-row .table-body-col:first-child {
  width: 24%;
}
::ng-deep ngb-pagination .pagination .page-item a.page-link {
  font-size: 12px !important;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip {
  max-width: 500px !important;
  width: 500px !important;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip .mat-mdc-tooltip-surface {
  box-shadow: 0 0 4px 0 #e2e0e0;
  font-family: "Poppins", sans-serif !important;
  font-size: 12px !important;
  font-weight: 400;
  font-family: "Poppins", sans-serif !important;
  max-width: 100% !important;
}
.hire-search-card-filters {
  padding: 8px 12px;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.empty-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  height: 80vh;
}
.toggle-container2 {
  position: relative;
  display: inline-flex;
  background: #e5e5e5;
  border-radius: 20px;
  padding: 4px;
  cursor: pointer;
}
.toggle-container2 span {
  position: relative;
  z-index: 2;
  padding: 6px 16px;
  font-size: 14px;
  color: #555;
  transition: color 0.3s ease;
}
.toggle-container2 span.active {
  color: #fff;
}
.toggle-slider2 {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 50%;
  height: calc(100% - 8px);
  background: #28a745;
  border-radius: 20px;
  transition: transform 0.3s ease;
  z-index: 1;
  color: #fff;
}
.toggle-slider2.insights {
  transform: translateX(100%);
}
.toggle-slider2.profiles {
  transform: translateX(0%);
}
.ml-auto {
  margin-left: auto;
}
.pos-sticky-top {
  position: sticky;
  top: 16px;
  z-index: 7;
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.05);
}
.pos-sticky-top::before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 16px;
  background-color: #fafbfc;
  top: -16px;
  left: 0;
}
.pipeline-export-modal-content {
  border-radius: 7px !important;
  overflow: hidden;
}
.pipeline-export-modal-content .modal-header {
  background-color: #f7f8f9;
  border-radius: 10px 10px 0 0;
  border-bottom: none;
}
.pipeline-export-modal-content .modal-header .btn-close {
  background-color: #f7f8f9;
  box-shadow: none !important;
  outline: none !important;
}
.pipeline-export-modal-content .modal-header .btn-close:focus,
.pipeline-export-modal-content .modal-header .btn-close:active {
  box-shadow: none !important;
  outline: none !important;
}
.pipeline-export-options {
  display: flex;
  flex-direction: column;
}
.pipeline-export-options .pipeline-export-option {
  display: flex;
  align-items: center;
  padding: 0.65rem 0.25rem;
  font-size: 13px;
  color: #484b59;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.pipeline-export-options .pipeline-export-option:last-child {
  border-bottom: none;
}
.pipeline-export-options .pipeline-export-option:hover {
  background-color: #e4f1f3;
  color: #2e93a1;
}
.pipeline-export-options .pipeline-export-option.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.pipeline-export-options .pipeline-export-option-icon {
  width: 20px;
  margin-right: 10px;
  text-align: center;
  color: #969696;
}
::ng-deep ngb-modal-window.quicksearchmodal .modal-dialog {
  max-width: 800px;
}
/*# sourceMappingURL=hire-talent-insights.component-3KUTPH6M.css.map */
